// Utilidades de RUT chileno (validación módulo 11 y formato 00000000-A).

// Valida formato + dígito verificador (módulo 11). Devuelve true/false.
export function validarRutChileno(rut) {
  if (!rut) return false;
  const limpio = String(rut).replace(/[.\s-]/g, '').toUpperCase();
  if (limpio.length < 2) return false;
  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);
  if (!/^\d+$/.test(cuerpo) || !/^[0-9K]$/.test(dv)) return false;
  if (parseInt(cuerpo, 10) === 0) return false;
  let suma = 0, factor = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo[i], 10) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const resto = 11 - (suma % 11);
  const dvCalc = resto === 11 ? '0' : resto === 10 ? 'K' : String(resto);
  return dvCalc === dv;
}

// Formatea a '00000000-A' (cuerpo con ceros a la izquierda hasta 8 dígitos + guión + DV).
// Devuelve null si no es parseable. No valida DV (usar validarRutChileno para eso).
export function formatearRut(rut) {
  const clean = String(rut || '').replace(/[^0-9kK]/g, '').toUpperCase();
  if (clean.length < 2) return null;
  const dv = clean.slice(-1);
  const cuerpo = clean.slice(0, -1);
  if (!/^\d+$/.test(cuerpo) || parseInt(cuerpo, 10) === 0 || cuerpo.length > 8) return null;
  return `${cuerpo.padStart(8, '0')}-${dv}`;
}

// Iter 292.a (Carlos, feb-2026) — Helper compartido para abrir la consulta
// de situación tributaria en el SII. El SII no permite prellenar por URL,
// así que copiamos el RUT al portapapeles y abrimos el formulario.
// - `rut`: RUT a copiar (string). Puede venir con puntos/guiones.
// - `toast`: opcional. Si se pasa `{ success, info, error }` (por ejemplo
//   la instancia de `sonner`), se avisa al usuario. Si no se pasa, solo
//   se abre la pestaña sin feedback.
export function consultarSII(rut, toast) {
  const limpio = String(rut || '').trim();
  if (!limpio) {
    if (toast?.error) toast.error('Ingresa el RUT primero para consultarlo en el SII.');
    return false;
  }
  try {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(limpio);
      if (toast?.success) toast.success('RUT copiado. Pégalo en la consulta del SII (se abrió en otra pestaña).');
    } else if (toast?.info) {
      toast.info('Se abrió la consulta del SII. Ingresa el RUT manualmente.');
    }
  } catch {
    if (toast?.info) toast.info('Se abrió la consulta del SII. Ingresa el RUT manualmente.');
  }
  window.open('https://www2.sii.cl/stc/noauthz', '_blank', 'noopener,noreferrer');
  return true;
}
